import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { Component } from '@wordpress/element';
import { createHigherOrderComponent, useFocusReturn } from '@wordpress/compose';
import deprecated from '@wordpress/deprecated';
/**
 * Returns true if the given object is component-like. An object is component-
 * like if it is an instance of wp.element.Component, or is a function.
 *
 * @param {*} object Object to test.
 *
 * @return {boolean} Whether object is component-like.
 */

function isComponentLike(object) {
  return object instanceof Component || typeof object === 'function';
}
/**
 * Higher Order Component used to be used to wrap disposable elements like
 * sidebars, modals, dropdowns. When mounting the wrapped component, we track a
 * reference to the current active element so we know where to restore focus
 * when the component is unmounted.
 *
 * @param {(WPComponent|Object)} options The component to be enhanced with
 *                                      focus return behavior, or an object
 *                                      describing the component and the
 *                                      focus return characteristics.
 *
 * @return {Function} Higher Order Component with the focus restauration behaviour.
 */


export default createHigherOrderComponent(function (options) {
  var HoC = function HoC() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        onFocusReturn = _ref.onFocusReturn;

    return function (WrappedComponent) {
      var WithFocusReturn = function WithFocusReturn(props) {
        var ref = useFocusReturn(onFocusReturn);
        return createElement("div", {
          ref: ref
        }, createElement(WrappedComponent, props));
      };

      return WithFocusReturn;
    };
  };

  if (isComponentLike(options)) {
    var WrappedComponent = options;
    return HoC()(WrappedComponent);
  }

  return HoC(options);
}, 'withFocusReturn');
export var Provider = function Provider(_ref2) {
  var children = _ref2.children;
  deprecated('wp.components.FocusReturnProvider component', {
    hint: 'This provider is not used anymore. You can just remove it from your codebase'
  });
  return children;
};
//# sourceMappingURL=index.js.map